import React from "react";
import { motion } from "framer-motion";
import { UserGroupIcon, ViewfinderCircleIcon, RocketLaunchIcon } from "@heroicons/react/24/outline";

const EtEternityHero = () => {

  // First Created - 03 Oct 2025
  // Author - Atul Pandey
  // Purpose - Hero for Eternity Solutions homepage — introduces brand mission and connection points
  // Audience - SME Tech-Services founders, leaders, and investors
  // Updated - 04 Oct 2025 - Refined the sections to communicate our purpose anchors more effectively
  // Updated - 11 Nov 2025 - Refined the links - meet Trinity /trinity/meet and Learn More - href to mission
  // Updated - 05 Dec 2025 - Removed SME from the Hero text

  return (
    <section
      id="home"
      className="h-screen flex items-center justify-center relative bg-gradient-to-br from-gray-900 via-black to-orange-900 text-white overflow-hidden"
    >
      {/* Subtle animated background pattern */}
      <div className="absolute inset-0 opacity-15 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" />

      {/* Main Content */}
      <motion.div
        className="text-center z-10 px-4 max-w-4xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        {/* Headline with animated emphasis */}
        {/* <motion.h1
        //   className="text-4xl md:text-6xl font-bold mb-6 leading-tight"
          className="text-4xl md:text-6xl font-bold mb-6 leading-snug md:leading-[1.2] md:space-y-2 flex flex-col md:block"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Igniting <span className="text-orange-500 animate-pulse">Growth</span>.{" "}
          Empowering <span className="text-orange-400">Leaders</span>. 
        
        </motion.h1> */}
        {/* <motion.h1
            className="text-3xl sm:text-4xl md:text-6xl font-bold mb-6 leading-normal md:leading-[1.2] space-y-1 md:space-y-0"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
        >
            <span className="block md:inline">
                Igniting <span className="text-orange-500 animate-pulse">Growth</span>.
            </span>
            <span className="block md:inline">
                Empowering <span className="text-orange-400">Leaders</span>.
            </span>
        </motion.h1> */}

        <motion.h1
          className="text-3xl sm:text-4xl md:text-6xl font-bold mb-6 leading-normal md:leading-[1.2] space-y-1 md:space-y-0"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <span className="block sm:whitespace-nowrap">
            Igniting <span className="text-orange-500 animate-pulse">Growth</span>.
          </span>
          <span className="block sm:whitespace-nowrap">
            Empowering <span className="text-orange-400">Leaders</span>.
          </span>
        </motion.h1>




        {/* Subheading — sharper positioning and empathy */}
        <motion.p
          className="text-lg md:text-xl text-gray-300 mb-8 max-w-4xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          {/* We help SME tech-services founders, CEOs, and investors build ecosystems of{" "}
          <span className="text-orange-400">high-performance growth.</span> Led by <span className="text-orange-600 font-bold">purpose</span>, powered
          by people, and amplified by AI. */}
          {/* 25 Oct 2025 */}
          {/* 25 Oct 2025 */}
          {/* We help tech-led SME Founders and CxOs build ecosystems of{" "} */}
          {/* 05 Dec 2025 - removed SME*/}
          We help tech-led Founders and CxOs build ecosystems of{" "}
          <span className="text-orange-400">high-performance growth.</span> Led by <span className="text-orange-600 font-bold">purpose</span>, powered
          by people, and amplified by AI.
        </motion.p>

        {/* Contextual CTAs */}
        <motion.div
          className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.1 }}
        >
          <a
            href="/clients"
            className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg shadow-lg font-semibold"
          >
            <UserGroupIcon className="h-5 w-5 inline-block mr-2" />
            I’m a Founder / CxO
          </a>
          <a
            // href="/investors"
            href="#mission" // 11 Nov 2025
            className="bg-white/10 hover:bg-white/20 px-6 py-3 rounded-lg font-semibold"
          >
            <ViewfinderCircleIcon className="h-5 w-5 inline-block mr-2" />
            {/* I’m an Investor */}
             Learn More {/* 11 Nov 2025*/}
          </a>
          <a
            href="/trinity/meet"
            className="bg-white/10 hover:bg-white/20 px-6 py-3 rounded-lg font-semibold"
          >
            <RocketLaunchIcon className="h-5 w-5 inline-block mr-2" />
            Meet Trinity
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default EtEternityHero;